import React, { FunctionComponent } from 'react'
import { Card, ButtonContainer } from '@vwfs-bronson/bronson-react'
import { Output } from '../../../Text'
import TextsRender from '../../../common/components/TextsRender/TextsRender'
import OrderedListRender from '../../../common/components/OrderedListRender/OrderedListRender'

export type BasicSectionProps = {
  section: string,
  originSystem?: string,
  prefill?: any,
  buttons?: FunctionComponent,
  templateValues?: any,
  descriptionListData?: any,
}

const BasicSection: FunctionComponent<BasicSectionProps> = props => {
  let { section, originSystem, buttons, templateValues } = props;

  const title = Output.resolve(`pages.signatureSuccess.${originSystem ? `${originSystem}.` : ''}${section}.title`)
  const texts = Output.resolve(`pages.signatureSuccess.${originSystem ? `${originSystem}.` : ''}${section}.texts`)
  const orderedList =
    Output.resolve(`pages.signatureSuccess.${originSystem ? `${originSystem}.` : ''}${section}.orderedList`)

  return (
    <Card
      title={title}
      className="u-text-left"
    >
      {/* Texts */}
      <TextsRender
        texts={texts}
        templateValues={templateValues}
      />

      {/* Ordered List */}
      <OrderedListRender
        orderedList={orderedList}
        templateValues={templateValues}
      />

      {/* Buttons component */}
      {buttons
        ? (
          <ButtonContainer nav right className="u-mt">
            {buttons}
          </ButtonContainer>
        )
        : <></>
      }
    </Card>
  )
}

export default BasicSection;
